import * as React from 'react';
import classNames from 'classnames';
import { ETrend } from '../../types/realtyValuation';
import * as styles from './styles.css';

interface IPriceTrendProps {
  trend: ETrend;
}

export function PriceTrend({ children, trend }: React.PropsWithChildren<IPriceTrendProps>) {
  return <span className={classNames(styles['delta'], styles[`delta_trend__${trend}`])}>{children}</span>;
}
